import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
// import { initializeApp } from "firebase/app";

// import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyBnzBrnMoz3XiKnQ5FtoIgFN_cPqVEXxu0",
  authDomain: "ashik-plan.firebaseapp.com",
  projectId: "ashik-plan",
  storageBucket: "ashik-plan.appspot.com",
  messagingSenderId: "318143729009",
  appId: "1:318143729009:web:3759f5662c3cf49a4d7ad0",
  measurementId: "G-L1PTGE4B37",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export default firebaseConfig;
